<template>
  <div>
    <div class="row align-items-end">
      <div class="col-auto flex-grow-1">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="select_1_1">Факультет <span>*</span></label>
              <select
                class="form-control"
                id="select_1_1"
                v-model="fak.val"
                @change="fakSelect"
                :disabled="fak.disabled"
                required
              >
                <option value="0" selected disabled>
                  -- выбрать факультет --
                </option>
                <template v-if="fak.items != null">
                  <option
                    v-for="item in fak.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="select_1_11">Багыт <span>*</span></label>
              <select
                class="form-control"
                id="select_1_11"
                v-model="direction.val"
                @change="directionSelect"
                :disabled="direction.disabled"
                required
              >
                <option value="0" selected disabled>
                  -- выбрать направления --
                </option>
                <template v-if="direction.items != null">
                  <option
                    v-for="item in direction.items"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.shifr + " " + item.name_kg }}
                  </option>
                </template>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <button
          class="btn btn-primary mb-4 ml-auto d-block"
          style="white-space: nowrap"
          @click="addModalShow"
          :class="{ 'is-loading': !isAddActive }"
        >
          Добавить
        </button>
      </div>
    </div>
    <hr class="mt-0 mb-2" />
    <template v-if="spec.items.length">
      <div class="row align-items-center">
        <div class="col-auto mb-2" v-if="newSearchList.length">
          <PerPageLenth
            class="mr-3"
            :page="page"
            :perPage="perPage"
            :allDataLenth="newSearchList.length"
          />
          <PerPageCount :perPage="perPage" @perPageSet="perPageSet" />
        </div>
        <div class="col-auto ml-auto mb-2">
          <div class="row">
            <div class="col-auto">
              <div class="input-affix">
                <i class="prefix-icon anticon anticon-search"></i>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="searchText"
                  placeholder="Поиск"
                />
              </div>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-sm btn-icon btn-secondary btn-tone excel"
                :disabled="!newSearchList.length"
                :class="{ excelHide: !newSearchList.length }"
                @click="downloadFile"
              >
                <i class="anticon anticon-file-excel"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-0 mb-2" />
    </template>
    <template v-if="newSearchList.length">
      <table
        class="table table-sm table-responsive-md table-striped table-hover"
      >
        <thead class="">
          <tr>
            <th scope="col">#</th>
            <th scope="col">Кыргызча</th>
            <th scope="col">Русский</th>
            <th scope="col">English</th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин/о
            </th>
            <th scope="col" class="text-center" style="white-space: nowrap">
              Ин/з
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in newDatalist" :key="item.id">
            <th scope="row">{{ index + 1 }}</th>
            <td>{{ item.name_kg }}</td>
            <td>{{ item.name_ru }}</td>
            <td>{{ item.name_en }}</td>
            <td class="text-center">{{ item.id_integration_oo }}</td>
            <td class="text-center">{{ item.id_integration_zo }}</td>

            <td class="text-right">
              <!-- <button class="btn btn-primary btn-xs mr-1">btn-xs</button> -->
              <button
                class="btn btn-icon btn-sm btn-success btn-tone mr-1 mb-1 mb-lg-0"
                @click="editModalShow(item)"
              >
                <i class="anticon anticon-edit"></i>
              </button>
              <button
                class="btn btn-icon btn-sm btn-danger btn-tone"
                @click="deleteModalShow(item)"
              >
                <i class="anticon anticon-delete"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <hr />
    </template>
    <div v-else class="noTdData">Нет данных</div>
    <Pagination
      :total="newSearchList.length"
      :perPage="perPage"
      @activePage="currentPage"
    />
    <Modal :isShow="isAddModalShow" @closeModal="addModalClose">
      <template v-slot:title> Добавить специальность </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="spec.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="spec.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="spec.val.name_en"
            required
          />
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_1">№ Интеграции очный</label>
              <input
                type="text"
                class="form-control"
                id="in_1"
                v-model="spec.val.id_integration_oo"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_2">№ Интеграции заочный</label>
              <input
                type="text"
                class="form-control"
                id="in_2"
                v-model="spec.val.id_integration_zo"
                required
              />
            </div>
          </div>
        </div>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="addModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="specPost">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isEditModalShow" @closeModal="editModalClose">
      <template v-slot:title> Изменить специальность </template>
      <template>
        <div class="form-group">
          <label for="kg_l">Кыргызча</label>
          <input
            type="text"
            class="form-control"
            id="kg_l"
            v-model="spec.val.name_kg"
            required
          />
        </div>
        <div class="form-group">
          <label for="ru_l">Русский</label>
          <input
            type="text"
            class="form-control"
            id="ru_l"
            v-model="spec.val.name_ru"
            required
          />
        </div>
        <div class="form-group">
          <label for="en_l">English</label>
          <input
            type="text"
            class="form-control"
            id="en_l"
            v-model="spec.val.name_en"
            required
          />
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_1">№ Интеграции очный</label>
              <input
                type="text"
                class="form-control"
                id="in_1"
                v-model="spec.val.id_integration_oo"
                required
              />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label for="in_2">№ Интеграции заочный</label>
              <input
                type="text"
                class="form-control"
                id="in_2"
                v-model="spec.val.id_integration_zo"
                required
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="editModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click="edtS">
          Сохранить
        </button>
      </template>
    </Modal>
    <Modal :isShow="isDeleteModalShow" @closeModal="deleteModalClose">
      <template v-slot:title> Удалить специальность </template>

      <template>
        <h5>Вы действительно хотите удалить?</h5>
        <template v-if="newDatalist.length">
          <p>{{ spec.val.name_kg }}</p>
          <p>{{ spec.val.name_ru }}</p>
          <p>{{ spec.val.name_en }}</p>
        </template>
      </template>

      <template v-slot:footer>
        <button
          type="button"
          class="btn btn-danger mr-3"
          @click="deleteModalClose"
        >
          Отмена
        </button>
        <button type="button" class="btn btn-primary" @click.prevent="deleteS">
          Подтвердить
        </button>
      </template>
    </Modal>
  </div>
</template>
<script>
import xlsx from "json-as-xlsx";

import Pagination from "@/components/others/Pagination.vue";
import PerPageLenth from "@/components/others/PerPageLenth.vue";
import PerPageCount from "@/components/others/PerPageCount.vue";
import Modal from "@/components/others/Modal.vue";

export default {
  name: "Speciality",
  components: {
    Pagination,
    PerPageLenth,
    PerPageCount,
    Modal,
  },
  data() {
    return {
      isAddModalShow: false,
      isEditModalShow: false,
      isDeleteModalShow: false,

      fak: { disabled: true, items: null, val: 0 },
      direction: { disabled: true, items: null, val: 0 },
      spec: { disabled: true, items: [], val: {} },
      dindex: null,
      did: null,
      page: 1,
      perPage: 10,
      searchText: "",

      isAddActive: false,
    };
  },
  computed: {
    newSearchList() {
      const regEx = new RegExp(this.searchText, "i");
      return this.spec.items.filter((x) => x.name_kg.match(regEx));
    },
    newDatalist() {
      return this.newSearchList.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },
  },
  methods: {
    currentPage(i) {
      this.page = i;
    },
    perPageSet(count) {
      this.perPage = count;
    },
    downloadFile() {
      let data = [
        {
          sheet: "Направления",
          columns: [
            { label: "id", value: "id" },
            { label: "Кыргызча", value: "name_kg" },
            { label: "Русский", value: "name_ru" },
            { label: "English", value: "name_en" },
            { label: "Интеграция очный", value: "id_integration_oo" },
            { label: "Интеграция заочный", value: "id_integration_zo" },
          ],
          content: [...this.newSearchList],
        },
      ];
      let settings = {
        fileName: "Направления",
      };
      xlsx(data, settings);
    },
    addModalShow() {
      this.spec.val = {};
      this.isAddModalShow = true;
    },
    addModalClose() {
      this.isAddModalShow = false;
    },
    editModalShow(item) {
      this.spec.val = {...item};
      this.isEditModalShow = true;
    },
    editModalClose() {
      this.isEditModalShow = false;
    },
    deleteModalShow(item) {
      this.spec.val = {...item};
      this.isDeleteModalShow = true;
      
    },
    deleteModalClose() {
      this.isDeleteModalShow = false;
    },
    async getFak() {
      try {
        const data = (await this.$api.plan.plan_faculty()).data;
        this.fak.items = data;
        this.fak.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getDirection() {
      try {
        const data = (
          await this.$api.plan.plan_direction({
            id_faculty: this.fak.val,
          })
        ).data;
        this.direction.items = data;
        this.direction.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpec() {
      try {
        const data = (
          await this.$api.plan.plan_speciality({
            id_direction: this.direction.val,
          })
        ).data;
        this.spec.items = data;
        this.spec.disabled = false;
      } catch (error) {
        console.log(error);
      }
    },
    async add_spes() {
      try {
        await this.$api.facultySpec.add_spes({
          id_faculty: this.fak.val,
          id_direction: this.direction.val,
          ...this.spec.val,
        });
        this.$nt("Успешно сохранен", "success");
        this.spec.val = {};
        this.addModalClose();
        this.getSpec();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка сохранений", "dagner");
      }
    },
    async update_spes() {
      try {
        await this.$api.facultySpec.update_spes(this.spec.val);
        this.$nt("Успешно изменен", "success");
        this.spec.val = {};
        this.editModalClose();
        this.getSpec();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка изменения", "dagner");
      }
    },
    async delete_spes() {
      try {
        await this.$api.facultySpec.delete_spes({
          id: this.spec.val.id
        });
        this.$nt("Успешно удален", "success");  
        this.spec.val = {};       
        this.deleteModalClose();
        this.getSpec();
      } catch (error) {
        console.log(error.message);
        this.$nt("Ошибка удаления", "dagner");
      }
    },
    fakSelect() {
      this.isAddActive = false;
      this.direction.val = 0;
      this.spec.items = [];
      this.spec.disabled = true;
      this.getDirection();
    },
    directionSelect() {
      this.isAddActive = true;
      this.spec.items = [];
      this.getSpec();
    },
    specPost() {
      this.add_spes();      
    },
    edtS() {
      this.update_spes();      
    },
    deleteS() {
      this.delete_spes();
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.getFak();
    });
  },
};
</script>
<style lang="scss" scoped>
td:last-child {
  word-wrap: none;
}
</style>
